import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.necessaryTimeArray,
    class: "my-1 p-datatable-sm min-w-max max-w-full",
    editMode: _ctx.editable ? 'cell' : null,
    onCellEditComplete: _ctx.onCellEditComplete
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(`${_ctx.boundFor}線`), 1)
    ]),
    footer: _withCtx(() => [
      _createTextVNode(" 合計" + _toDisplayString(_ctx.necessaryTimeArray.reduce((prev, cur) => prev + cur.necessaryTime, 0)) + "分 ", 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: "from",
        header: "発",
        class: "w-4 max-w-0"
      }, {
        body: _withCtx((slotProps) => [
          _createTextVNode(_toDisplayString(_ctx.getStationName(slotProps.data.from)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        field: "to",
        header: "着",
        class: "w-4 max-w-0"
      }, {
        body: _withCtx((slotProps) => [
          _createTextVNode(_toDisplayString(_ctx.getStationName(slotProps.data.to)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        field: "necessaryTime",
        header: "分",
        class: "max-w-0"
      }, {
        editor: _withCtx(({ data, column }) => [
          _createVNode(_component_InputNumber, {
            modelValue: data[column.props.field],
            "onUpdate:modelValue": ($event: any) => ((data[column.props.field]) = $event),
            class: "w-3rem"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value", "editMode", "onCellEditComplete"]))
}